<template>
  <div class="main-content">
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <h2>IDP Period</h2>
              </div>
              <div class="d-flex justify-content-end mb-5">
                <b-button
                  v-if="listTabMenu?.privilages?.create"
                  v-b-modal.modal-1
                  variant="primary"
                  @click="isAdd = true">
                  <span class="fe fe-file-plus"></span>
                  Add IDP Period
                </b-button>
              </div>
              <vue-good-table
                :line-numbers="true"
                :columns="columns"
                :rows="idpPeriod"
                :sort-options="{
                  enabled: false
                }"
                :pagination-options="{
                  enabled: false,
                  mode: 'pages',
                  position: 'bottom',
                  perPage: 10,
                  perPageDropdown: [10, 50, 100],
                  dropdownAllowAll: false,
                  setCurrentPage: 1,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page',
                  allLabel: 'All'
                }"
                style-class="vgt-table border-0 table">

                <!-- Loading -->
                <div slot="emptystate" class="text-center font-size-14">
                  No data available
                </div>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'start_date'">
                    {{ formatDate(props.row.start_date) }}
                  </span>
                </template>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'end_date'">
                    {{ formatDate(props.row.end_date) }}
                  </span>
                </template>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'min_hours'">
                    {{ props.row.min_hours }}
                  </span>
                </template>
                <template slot="table-row" slot-scope="props">
                  <!-- Table Action -->
                  <span v-if="props.column.field == 'action'">
                    <b-button
                      v-if="listTabMenu.privilages.update && props.vstatus != 'closed'"
                      class="no-wrap btn-pill"
                      variant="warning"
                      size="sm"
                      @click="updateData(props.row)">
                      <span class="fe fe-edit"></span>
                    </b-button>
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="isAdd" title="Create IDP Period" size="lg" hide-footer>
        <div class="form-group">
          <div class="row">
            <div class="col-3">
              <h5 class="fw-bold mt-5">Start Date</h5>
            </div>
            <div class="col-9">
              <input
                type="date"
                class="form-control mt-4"
                placeholder="Pilih Tanggal"
                v-model="bodyAdd.startDate" />
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <h5 class="fw-bold mt-5">End Date</h5>
            </div>
            <div class="col-9">
              <input
                type="date"
                class="form-control mt-4"
                placeholder="Pilih Tanggal"
                v-model="bodyAdd.endDate" />
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <h5 class="fw-bold mt-5">Minimum Learning Hours</h5>
            </div>
            <div class="col-9">
              <input
                type="number"
                class="form-control mt-4"
                placeholder="Minimum Learning Hours"
                v-model="bodyAdd.min_hours" />
            </div>
          </div>
        </div>
        <b-button class="float-end" variant="primary" @click="createIdpPeriod()"
          >Submit
        </b-button>
      </b-modal>
      <b-modal v-model="isUpdate" title="Update IDP Period" size="lg" hide-footer>
        <div class="form-group">
          <div class="row">
            <div class="col-3">
              <h5 class="fw-bold mt-5">Start Date</h5>
            </div>
            <div class="col-9">
              <input
                type="date"
                class="form-control mt-4"
                placeholder="Pilih Tanggal"
                v-model="bodyUpdate.startDate" 
                :disabled="isDisStartDate"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <h5 class="fw-bold mt-5">End Date</h5>
            </div>
            <div class="col-9">
              <input
                type="date"
                class="form-control mt-4"
                placeholder="Pilih Tanggal"
                v-model="bodyUpdate.endDate" />
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <h5 class="fw-bold mt-5">Minimum Learning Hours</h5>
            </div>
            <div class="col-9">
              <input
                type="number"
                class="form-control mt-4"
                placeholder="Minimum Learning Hours"
                v-model="bodyUpdate.min_hours" />
            </div>
          </div>
        </div>
        <b-button class="float-end" variant="primary" @click="updateIdpPeriod()"
          >Submit
        </b-button>
      </b-modal>
    </div>
  </div>
</template>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";

export default {
  name: "idpPeriod",
  data() {
    return {
      columns: [
        // {
        //   label: "id",
        //   field: "id",
        //   thClass: "table-header text-muted w-50 font-weight-bold",
        //   tdClass: "color-secondary align-middle",
        // },
        {
          label: "Start Date",
          field: "start_date",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle"
        },
        {
          label: "End Date",
          field: "end_date",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle"
        },
        {
          label: "Min Hours",
          field: "min_hours",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle"
        },
        {
          label: "Status",
          field: "status",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle"
        },
        // {
        //   label: "Proficiency Standard",
        //   field: "proficiency_standard",
        //   thClass: "table-header no-wrap text-muted font-weight-bold",
        //   tdClass: "no-wrap color-secondary align-middle",
        //   width: "20%"
        // }
        {
          label: "ACTION",
          field: "action",
          thClass: "table-header no-wrap text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        }
      ],
      listTabMenu: {},
      bodyAdd: {
        startDate: "",
        endDate: "",
        min_hours : 0
      },
      bodyUpdate: {
        id: "",
        startDate: "",
        endDate: "",
        min_hours : 0
      },
      idpPeriod: [],
      isAdd: false,
      isUpdate: false,
      isDisStartDate: false,
    };
  },
  computed: {},
  methods: {
    formatDate(value) {
      if (!value) return "Invalid date"; 
      const dateMoment = this.$moment(value);
      if (dateMoment.isValid()) {
        return dateMoment.format("DD-MM-YYYY"); 
      }
      return "Invalid date"; 
    },
    updateData(e) {
      this.bodyUpdate.id = e.id; 
      this.bodyUpdate.startDate = e.start_date; 
      this.bodyUpdate.endDate = e.end_date; 
      this.bodyUpdate.min_hours = e.min_hours; 
      if (e.status == 'open') {
        this.isDisStartDate = true;
      } else {
        this.isDisStartDate = false;
      }
      this.isUpdate = true;
    },
    addIdpPeriod() {
      this.isAdd = true;
    },
    createIdpPeriod() {
      let body = {
        start_date: this.bodyAdd.startDate,
        end_date: this.bodyAdd.endDate,
        min_hours : this.bodyAdd.min_hours
      };
      this.$store
        .dispatch("idpPeriod/createIdpPeriod", body)
        .then((response) => {
          this.$swal
            .fire({
              icon: "success",
              title: "Success",
              text: "IDP Period Saved."
            })
            .then(() => {
              this.isAdd = false;
              this.getIdpPeriod();
              this.setTodayDate();
            });
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Periode IDP belum berhasil disimpan: " +
              (error.response?.data?.error || error.message),
            "error"
          );
        });
    },
    updateIdpPeriod() {
      let body = {
        id: this.bodyUpdate.id,
        data: {
          start_date: this.bodyUpdate.startDate,
          end_date: this.bodyUpdate.endDate,
          min_hours : this.bodyUpdate.min_hours
        }
      };
      this.$store
        .dispatch("idpPeriod/updateIdpPeriod", body)
        .then((response) => {
          this.$swal
            .fire({
              icon: "success",
              title: "Success",
              text: "IDP Period Saved."
            })
            .then(() => {
              this.isUpdate = false;
              this.getIdpPeriod();
              this.setTodayDate();
            });
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Periode IDP belum berhasil disimpan: " +
              (error.response?.data?.error || error.message),
            "error"
          );
        });
    },
    getIdpPeriod() {
      this.$store.dispatch("idpPeriod/getIdpPeriod").then((res) => {
        this.idpPeriod = res.data;
      });
    },
    setIdpPeriod() {
      console.log(this.bodyAdd.startDate);
      console.log(this.bodyAdd.startDate);
    },
    setTodayDate() {
      const today = this.$moment(new Date()).format("YYYY-MM-DD");
      this.bodyAdd.startDate = today;
      this.bodyAdd.endDate = today;
    }
  },
  mounted() {
    this.setTodayDate();
    this.getIdpPeriod();
    const listMenu = JSON.parse(localStorage.getItem('listMenu') || [])
    const currentPath = window.location.pathname; // Path dari URL saat ini
    const menu = listMenu.find((menu) =>
      menu.link === currentPath || menu.children.find((child) => child.link === currentPath)
    );
    this.listTabMenu = menu.children.find((item) => item.link === currentPath);
  }
};
</script>
<style></style>
